<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12 print-media">
            <vs-breadcrumb 
              align="left"
              :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard',
                    },
                    {
                      title: 'Event Brief Report',
                      url: '/#/dashboard/Admin/trainingBriefReport',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <!-- <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Event Information</h6>
            </div>-->
          </div>
          <BriefReportAdmin />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BriefReportAdmin from "../../commonPages/BriefTrainingReport";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
export default {
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    BriefReportAdmin
  },
  data: () => ({
    isSidebar: false
  })
};
</script>

<style scoped>
</style>